<template>
  <div
    style="position: relative"
  >
    <div
      v-if="showResults"
      class="backdrop"
      @click="showResults=false"
    >
    </div>
    <v-text-field
      ref="searchField"
      v-model="result"
      :label="label"
      :loading="isLoading"
      @input="search = result"
      @keydown.esc="cancelSearch"
    ></v-text-field>
    <v-card
      class="search-results mt-n4"
      v-if="showResults"
    >
      <v-list-item v-for="item in entries" :key="item.name" @click="select(item)">
        <v-list-item-content>
          <v-list-item-title>{{item.name}}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-card>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapActions } from 'vuex'

export default {
  props: {
    value: {
      required: true,
      type: String
    },
    label: {
      required: true,
      type: String
    }
  },
  data () {
    return {
      descriptionLimit: 60,
      entries: [],
      isLoading: false,
      result: null,
      search: null,
      searchTimeout: null,
      showResults: false
    }
  },
  methods: {
    ...mapActions('companies', ['businessRegister']),
    cancelSearch () {
      this.loading = false
      this.showResults = false
    },
    openResults () {
      if (this.entries.length) {
        this.showResults = true
      }
    },
    select (item) {
      this.$emit('selected', item)
      this.showResults = false
    },
    doSearchAfterPaste (event) {
      Vue.nextTick(() => {
        this.doSearch(event.target.value)
      })
    },
    doSearch (key) {
      if (!this.isLoading && key) {
        clearTimeout(this.searchTimeout)
        this.searchTimeout = setTimeout(() => {
          this.isLoading = true
          this.showResults = false
          this.entries = []

          this.businessRegister(key)
            .then(results => {
              if (results.length) {
                this.entries = results
                this.showResults = true
              }/*  else {
                this.$notify({
                  type: 'warning',
                  text: 'Nobeno podjetje se ne ujema z iskalnim nizom.'
                })
              } */
              this.$nextTick(() => {
                this.$nextTick(() => {
                  this.$refs.searchField.focus()
                })
              })
            })
            .finally(() => (this.isLoading = false))
        }, 700)
      }
    }
  },
  watch: {
    search (val) {
      this.doSearch(val)
    },
    value (val) {
      this.result = val
    },
    result (val) {
      if (val !== this.value) {
        this.$emit('input', val)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.backdrop {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}
.search-results {
  position: absolute;
  z-index: 10;
  max-height: 300px;
  width: 100%;
  overflow: auto;
}
</style>
